import { Injectable } from '@angular/core';
import {
  ClinicalReportPromptVersion, ClinicalReportPromptVersionInput,
} from '../../domain/models/clinical-report-prompt-version.model';
import {
  ClinicalReportPromptVersionDto, ClinicalReportPromptVersionRequestDto,
} from '../dtos/clinical-report-prompt-version.dto';

@Injectable()
export class ClinicalReportPromptVersionMapper {
  public toClinicalReportPromptVersion(dto: ClinicalReportPromptVersionDto): ClinicalReportPromptVersion {
    return {
      id: dto.Id,
      name: dto.Name ?? '',
      description: dto.Description ?? null,
      systemPromptFree: dto.SystemPromptFree ?? '',
      systemPromptTemplate: dto.SystemPromptTemplate ?? '',
      userPromptFree: dto.UserPromptFree ?? '',
      userPromptTemplate: dto.UserPromptTemplate ?? '',
      model: dto.Model ?? '',
      temperature: dto.Temperature ?? null,
      isDefault: dto.IsDefault === true,
      createdAtUtc: dto.CreatedAtUtc ?? '',
      updatedAtUtc: dto.UpdatedAtUtc ?? '',
    };
  }

  public toRequestDto(input: ClinicalReportPromptVersionInput): ClinicalReportPromptVersionRequestDto {
    return {
      Name: input.name,
      Description: input.description,
      SystemPromptFree: input.systemPromptFree,
      SystemPromptTemplate: input.systemPromptTemplate,
      UserPromptFree: input.userPromptFree,
      UserPromptTemplate: input.userPromptTemplate,
      Model: input.model,
      Temperature: input.temperature,
    };
  }
}
